import Address from "./Address";
import Nav from "@/components/Nav";
import Question from "./Questions";
import ContactForm from "./ContactForm";
import styles from "./styles.module.css";
import { Heading } from "@/components/Shared";
import { useEnergyJourney } from "@/hooks/useEnergyJourney";
import { questions, questionScenarios } from "@/data/energyJourneyQuestions";
import { FC, ReactNode } from "react";

const EnergyQuestionnaire: FC<{}> = ({}) => {
	const {
		currentQuestionIndex,
		userAnswers,
		address,
		contactDetails,
		handleSaveAnswer,
		handleSetAddress,
		handleSubmit,
		loading,
		error,
	} = useEnergyJourney();

	const questionKeysToShow = userAnswers[0]
		? questionScenarios[userAnswers[0] as "home" | "business"]
		: [];

	const questionComponents: ReactNode[] = [
		<Question
			onSaveAnswer={(answer: string) => handleSaveAnswer(answer)}
			answer={userAnswers[0] || ""}
			key={0}
			answers={questions.homeOrBusiness.answers}
			question={questions.homeOrBusiness.question}
			progress={questions.homeOrBusiness.progress}
		/>,
		...questionKeysToShow.map((questionKey, index) => (
			<Question
				onSaveAnswer={(answer: string) => handleSaveAnswer(answer)}
				answer={userAnswers[index + 1] || ""}
				key={index + 1}
				answers={questions[questionKey].answers}
				question={questions[questionKey].question}
				progress={questions[questionKey].progress}
			/>
		)),
	];

	return (
		<header>
			<Nav landing={true} />
			<div className={`${styles.header} d-flex flex-fill`}>
				<div
					className={`container py-5 my-5 d-flex flex-column flex-fill`}
				></div>
			</div>

			<div
				className={` container d-flex justify-content-center align-items-center `}
			>
				<div
					className={`${styles.roundedBox} pt-sm-5 pt-4 ps-3 pe-3 ps-sm-5 pe-sm-5 pb-sm-5 pb-4 `}
				>
					<div className={` text-center mx-auto pb-1 pt-2 col-md-9`}>
						<Heading
							title="Find the right energy solution for your home."
							isBold={false}
							variant={3}
						/>
					</div>
					<div className="row mx-auto mt-3 ps-md-5 pe-md-5 ">
						{address.length === 0 ? (
							<Address setAddress={handleSetAddress} />
						) : (
							<>
								{currentQuestionIndex < questionComponents.length ? (
									questionComponents[currentQuestionIndex]
								) : (
									<>
										{contactDetails.firstName === "" && (
											<ContactForm
												submitContent={"Submit"}
												legalBit={""}
												handleSubmit={handleSubmit}
												loading={loading}
												error={error}
											/>
										)}
									</>
								)}
							</>
						)}
					</div>
				</div>
			</div>
		</header>
	);
};

export default EnergyQuestionnaire;
